import React from 'react';
import { useFormContext } from 'react-hook-form';
import useToggle from '_hooks/useToggle';
import './style.scss';

export default function YourSetting({
  onEdit,
}) {
  const [isOpen, toggleOpen] = useToggle(true);
  const { watch } = useFormContext() || {};

  const formPayTogether = watch ? watch('payTogether') : true;
  const formAdminCost = watch ? watch('adminCost') : '';
  const formItems = watch ? watch('items') : [];

  const paymentText = formPayTogether ? 'Pay together' : 'Pay separately';
  const adminFeeText = (formAdminCost && Number(formAdminCost) > 0)
    ? `$${Number(formAdminCost).toFixed(2)}`
    : 'None';
  const productsText = `${formItems?.length || 0} item(s)`;

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit();
    }
  };

  return (
    <>
    <div className="your-setting-card">
      <div className="your-setting-header" onClick={toggleOpen}>
        <div className="header-title">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#009A97"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
          </svg>
          <span>Your settings</span>
        </div>
        <div className="header-actions">
          <span className="btn-edit" onClick={handleEdit}>
            Edit
          </span>
          <svg
            className={`collapse-chevron ${isOpen ? 'open' : ''}`}
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#888780"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>

      {isOpen && (
        <div className="your-setting-body">
          <div className="setting-content">
            {/* Payment options */}
            <div className="setting-row">
              <span className="setting-label">Payment</span>
              <span className="setting-value">{paymentText}</span>
            </div>

            {/* Admin fee */}
            <div className="setting-row">
              <span className="setting-label">Admin fee</span>
              <span className="setting-value">{adminFeeText}</span>
            </div>

            {/* Products */}
            <div className="setting-section">
              <div className="setting-label">Products</div>
              <div className="setting-value">{productsText}</div>
            </div>
          </div>
        </div>
      )}
    </div>
    <div className="member-view-label">Member view</div>
    </>
  );
}
